import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevateYourImage from "./sections/ElevateYourImage";
import OurSignatureSolutions from "./sections/OurSignatureSolutions";
import HowWeWork from "./sections/HowWeWork";
import CaseStudies from "./sections/CaseStudies";
import StrategicSourcingVideo from "./sections/StrategicSourcingVideo";
import Industryiconrow from "./sections/Industryiconrow";
import TheMuseCollective from "./sections/TheMuseCollective";
import LetsBuildTogether from "./sections/LetsBuildTogether";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevateYourImage />
      <OurSignatureSolutions />
      <HowWeWork />
      <CaseStudies />
      <StrategicSourcingVideo />
      <Industryiconrow />
      <TheMuseCollective />
      <LetsBuildTogether />
      <Footer />
    </div>;
}